
export enum ResponseStatus {
    NotAuthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
    Gone = 410,
    InternalServerError = 500,
  }
  
  export enum StorageKeys {
    accessToken = 'accessToken',
    accessTokenExpiration = 'accessTokenExpiration',
    redirectPathname = 'redirectPathname',
    logoutRedirect = 'logoutRedirect',
  }
  
  export enum Action {
      ShouldDoLogout= 'true'
  }
  